import {useQuery} from 'react-query';
import {getListBrandOwner} from '.';

const useGetListBrandOwner = () => {
  const {data, isLoading} = useQuery({
    queryKey: ['list-brand-owner'],
    queryFn: getListBrandOwner,
  });

  return {data, isLoading};
};

export default useGetListBrandOwner;
